<template>
  <div class="popup__inner fixed z-40 pb-3 pt-4">
    <div class="popup__body flex justify-center flex-col items-center">
      <font-awesome-icon icon="heart" class="text-xl text-white" />
      <p class="text-xs mt-1 text-white text-NotoSansRegular">加入收藏</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notification',

  data () {
    return {
      timer: ''
    }
  },

  watch: {
    '$route' (to, from) {
      if (to.name !== from.name) {
        this.$store.dispatch('isAddingWish', false)
      }
    }
  },
  mounted () {
    this.timer = setTimeout(this.get, 1500)
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    get () {
      this.$store.dispatch('isAddingWish', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup__inner {
  background: rgba(74, 74, 74, 0.8) !important;
  top: 45%;
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 6rem;
  line-height: 1.5;
  letter-spacing: .05em;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-animation-name: example;
  -webkit-animation-duration: .3s;
  animation-name: example;
  animation-duration: .3s;
  animation-fill-mode: forwards;
}
@-webkit-keyframes example {
  0% {
    opacity: 0;
    transform: scale(2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    }
}

/* Standard syntax */
@keyframes example {
  0% {
    opacity: 0;
    transform: scale(2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    }
}
</style>
